(function () {
    document.addEventListener("DOMContentLoaded", function (event) {
    var mobileCarousels = document.querySelectorAll(".siema-carousel.carousel-with-thumbnails .slides");
    var numItems = document.querySelectorAll(".siema-carousel.carousel-with-thumbnails .slides figure");

        Array.prototype.forEach.call(mobileCarousels, function (el, i) {
            var carouselMobyleOnly = new Siema({
                selector: mobileCarousels[i],
                duration: 200,
                easing: 'ease-out',
                perPage: 1,

                onInit: function () {

                    this.printCurrentSlide();
                    this.slideToCurrent();

                    if (numItems.length > 1) {
                        this.addArrows();
                        this.addThumbnail();
                        this.updateThumbnail();
                        this.updateArrows();
                    }
                },
                onChange: function () {
                    this.updateThumbnail();
                    this.printCurrentSlide();
                    this.updateArrows();
                }
            });
        });
    });
})();